<template>
  <!-- 任务攻略组件 -->
  <!-- 当前引入自我探索所有任务 -->
  <div>
    <!-- 跳转项目攻略 -->
    <router-link  class="task-gl" :to="{
        path:'/faq_list',
        query:{
            cid:this.cid,
            cpid:this.pid
        }
    }">
        <img src="../../assets/hxz.png" >
        快速查看任务攻略
    </router-link>
  </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    props:['cid','pid']
}
</script>

<style lang="scss" scoped>
// 任务攻略
.task-gl{
    display: block;
    margin-top: 40px;
    font-size:26px;
    color: #666;
    text-align: left;
    text-decoration:underline;
    img{
        width:28px;
        height: 28px;
        margin-right: 12px;
    }
}
</style>